function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.242 10.357c0 5.672-5.256 10.27-11.738 10.27-1.163.003-2.32-.148-3.444-.448-.857.434-2.825 1.268-6.135 1.81-.293.048-.516-.258-.4-.53.519-1.227.988-2.862 1.13-4.353-1.798-1.804-2.89-4.167-2.89-6.75C.765 4.685 6.021.087 12.504.087c6.482 0 11.738 4.598 11.738 10.27zm-16.14 0a1.467 1.467 0 11-2.935 0 1.467 1.467 0 012.935 0zm5.869 0a1.467 1.467 0 11-2.935 0 1.467 1.467 0 012.935 0zm4.402 1.467a1.467 1.467 0 100-2.935 1.467 1.467 0 000 2.935z",
  fill: "#fff"
});
function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgChat;